<template>
  <div>
    <xm-overlay :show="mutableShow"></xm-overlay>
    <transition name="xm-popover">
      <div :class="'xm-popover ' + computedPosition"
           v-bind:style="{ top: top+'px', left: left+'px'}"
           v-if="mutableShow"
           ref="popover">
        <div class="angle"></div>
        <div class="inner">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>



<script>
import { isParent } from './Utils';

const AUTO = 'auto';
const TOP = 'top';
const BOTTOM = 'bottom';

export default {
  name: 'xm-popover',
  props: {
    trigger: {
      type: String,
      required: true
    },
    position: {
      type: String,
      default: AUTO
    },
    show: {
      type: Boolean,
      default: false
    },
    overlay: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 92
    }
  },

  data() {
    return {
      mutableShow: this.show,
      top: 0,
      left: 0,
      angleOffset: 0,
      computedPosition: TOP,
      triggerElement: undefined,
      parentElement: undefined
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.triggerElement = document.querySelector(this.trigger);
      this.parentElement = this.triggerElement.offsetParent;
      this.parentElement.addEventListener('scroll', this.locate);

      document.addEventListener('click', (e) => {
        if (!isParent(e.target, this.$refs.popover) && !isParent(e.target, this.triggerElement)) {
          this.mutableShow = false;
        }
      });
    });
  },

  watch: {
    mutableShow(v, ov) {
      if (v === true) {
        this.$nextTick(() => this.locate());
      }
    },
    show(v, ov) {
      this.mutableShow = v;
    }
  },

  methods: {
    locate() {
      // compute position
      if (!this.mutableShow || !this.triggerElement) {
        return false;
      }
      const el = this.$refs.popover;
      const t = this.triggerElement;
      const p = this.parentElement;
      const top = t.offsetTop - p.scrollTop;
      const tsize = t.getBoundingClientRect();
      const elsize = el.getBoundingClientRect();
      const psize = p.getBoundingClientRect();
      if (this.position !== AUTO) {
        this.computedPosition = this.position;
      } else if (top > psize.height / 2) {
        this.computedPosition = TOP;
      } else {
        this.computedPosition = BOTTOM;
      }

      this.left = t.offsetLeft - elsize.width / 2 + tsize.width / 2;

      if (this.left < 0) {
        const left = 4;
        this.angleOffset = this.left - left;
        this.left = left;
      } else if (this.left > psize.width - elsize.width) {
        const left = psize.width - elsize.width - 4;
        this.angleOffset = this.left - left;
        this.left = left;
      }

      if (this.computedPosition === TOP) {
        this.top = t.offsetTop - elsize.height - 30;
      } else {
        this.top = t.offsetTop + tsize.height + 30;
      }
    }
  }
};
</script>

<style lang="less">
@import '../core/variables.less';
@import '../core/mixins.less';

@border-color: rgba(0, 0, 0, .2);
.xm-popover {
  position: absolute;
  width: auto;
  padding: .02rem .08rem; // 1px for border not be hide by inner div
  background-color: white;
  text-align: center;
  font-size: .32rem;
  min-width: 3rem;
  max-width: 6rem;
  transition: opacity .3s;
  border: 0.01rem solid @color-split;
  border-radius: 0.12rem;


  opacity: 1;
  display: block;

  &.xm-popover-enter,
  &.xm-popover-leave-active {
    opacity: 0;
  }
}

.angle {
  width: .5rem;
  height: .5rem;
  .hairline-border(@border-color, 0);
  background-color: white;
  position: absolute;
  bottom: -.25rem;
  left: 50%;
  margin-left: -.25rem;
  z-index: 1;
  transform: rotate(45deg);
  transform-origin: center center;
}

.bottom .angle {
  bottom: initial;
  top: -.25rem;
}

.inner {
  position: relative;
  z-index: 10;
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Popover.vue